export default __webpack_public_path__ + "static/media/RightHandPitcher.74a7a37b.png";